import Email from './email/Email';
import ImportedId from './imported-id/ImportedId';
import oauth from './oauth';

export default {
	email: Email,
	imported_id: ImportedId,
	...oauth,
};
